import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const DashboardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  padding: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    padding: theme.spacing(1)
  }
}));

export const UserSidebar = styled(Box)(({ theme }) => ({
  width: '300px',
  flexShrink: 0,
  '&.mobile': {
    width: '100%',
    marginTop: theme.spacing(3)
  },
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}));

export const ProfileCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
  overflow: 'hidden'
}));

export const ProfileHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2)
  },
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: theme.palette.primary.light,
  position: 'relative'
}));

export const ProfileAvatar = styled('img')(({ theme }) => ({
  width: 120,
  height: 120,
  borderRadius: '50%',
  border: `4px solid ${theme.palette.background.paper}`,
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[2]
}));

export const ProfileContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3)
}));

export const SocialLink = styled('a')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  marginRight: theme.spacing(2),
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.shape.borderRadius,
  transition: 'all 0.2s',
  '&:hover': {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.action.hover
  }
}));

export const BookingsContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}));

export const BookingsHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  }
}));